export default "__VITE_ASSET__YOvLU7rE__"